import {apsEnums} from "../../shared/dto/aps.enums";
import * as angular from "angular";
import * as _ from "lodash";
import {Colors} from "../../shared/config/constant.module";

import auditTemplate from "./templates/auditDialog.tpl.html";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import DateUtilityService from "./dateutility.service";

export interface AuditDialogCtrl {
  close: () => void;
}

export interface UIAuditService {
  openAuditModal(content: apsViewModels.AuditReportItem, subject: string): angular.IPromise<boolean>;
}

export interface AuditDialogData {
    content: apsViewModels.AuditReportItem;
    subject: string;
}
  
class UIAuditDialogCtrl implements AuditDialogCtrl {

    private modalInstance: mm.foundation.modalInstance;
    public content: apsViewModels.AuditReportItem;
    public subject: string;
    private comments: string[];
  
    constructor($modalInstance: mm.foundation.modalInstance, data: AuditDialogData) {
      this.modalInstance = $modalInstance;
      this.content = data.content;
      this.comments = (data.content.comments && (data.content.comments.length > 0)) ? data.content.comments.split('|~|') : [];

      this.subject = data.subject;
    }
  
    close(): void {
      this.modalInstance.close(false);
    }

    formatTime(time: Date, timeZoneId: string): string {
      return DateUtilityService.formatTime(time, timeZoneId);
    }
}

class UIAuditSvc implements UIAuditService {

  private $window: angular.IWindowService;
  private $modal: mm.foundation.modal;

  constructor($window: angular.IWindowService, $modal: mm.foundation.modal) {
    this.$window = $window;
    this.$modal = $modal;
  }

  openAuditModal(content: apsViewModels.AuditReportItem, subject: string): angular.IPromise<boolean> {
    let modalConfirmation =
      this.$modal.open({
        template: auditTemplate,
        controller: 'uiAuditDialogCtrl as vm',
        resolve: {
          data: (): AuditDialogData => ({
            content: content,
            subject: subject
          })
        }
      });

    return modalConfirmation.result;
  }
}

export default angular
  .module('ui-audit', ['mm.foundation'])
  .service('uiAuditService', UIAuditSvc)
  .controller('uiAuditDialogCtrl', UIAuditDialogCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/utility/uiAudit.service.ts